import React from "react";
import "../UIcss/Footer.css";
import {
  FaCrown,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="ui-footer">
      <div className="footer-content">
        <div className="footer-brand-section">
          <div className="footer-logo">
            <FaCrown className="footer-logo-icon" />
            <span className="footer-logo-text">CODEPULSE-R.COM</span>
          </div>
          <p className="footer-tagline">
            Building the next generation of premium web interfaces with speed
            and elegance.
          </p>
          <div className="footer-socials">
            <a href="#" className="social-link" title="Facebook">
              <FaFacebook />
            </a>
            <a href="#" className="social-link" title="Twitter">
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/codepulse.r" target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
              <FaInstagram />
            </a>
            <a href="#" className="social-link" title="YouTube">
              <FaYoutube />
            </a>
          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-link-group">
            <h3>Library</h3>
            <Link to="/headings">Headings</Link>
            <Link to="/buttons">Buttons</Link>
            <Link to="/spinners">Spinners</Link>
            <Link to="/tables">Tables</Link>
          </div>
          <div className="footer-link-group">
            <h3>Resources</h3>
            <Link to="/home">Documentation</Link>
            <Link to="/colors">Design System</Link>
            <Link to="/icons">Icon Library</Link>
            <Link to="/animations">Animations</Link>
          </div>
          <div className="footer-link-group">
            <h3>Company</h3>
            <Link to="/about">About Us</Link>
            <a href="#">Contact</a>
            <a href="#">FAQ</a>
          </div>
          <div className="footer-link-group">
            <h3>Legal</h3>
            <a href="#">Terms of Service</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Cookie Policy</a>
            <a href="#">Security</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()}{" "}
          <a href="https://ui.codepulse-r.com" target="_blank">
            CodePulse-R
          </a>{" "}
          UI. All rights reserved.
        </p>
        <div className="footer-bottom-links">
          <span>Made with ❤️ for Developers</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
